/**
 * Banner PDP Sconto - Copy Code Functionality
 */
(function() {
  'use strict';

  // Use event delegation to handle dynamically added buttons
  function handleCopyClick(e) {
    const button = e.target.closest('.banner-copy-btn');
    if (!button) return;
    
    const codeToCopy = button.getAttribute('data-copy-code');
    
    if (!codeToCopy) {
      return;
    }

    // Copy to clipboard
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(codeToCopy).then(function() {
        showCopySuccess(button);
      }).catch(function(err) {
        console.error('Errore durante la copia:', err);
        fallbackCopyTextToClipboard(codeToCopy, button);
      });
    } else {
      // Fallback per browser più vecchi
      fallbackCopyTextToClipboard(codeToCopy, button);
    }
  }

  function initBannerCopyButtons() {
    // Remove existing listener if any
    document.removeEventListener('click', handleCopyClick);
    // Add event delegation listener
    document.addEventListener('click', handleCopyClick);
  }

  function fallbackCopyTextToClipboard(text, button) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        showCopySuccess(button);
      } else {
        console.error('Fallback: Impossibile copiare il testo');
      }
    } catch (err) {
      console.error('Fallback: Errore durante la copia', err);
    }
    
    document.body.removeChild(textArea);
  }

  function showCopySuccess(button) {
    const btnText = button.querySelector('.btn__text');
    if (!btnText) return;
    
    const originalText = btnText.textContent.trim();
    button.classList.add('copied');
    btnText.textContent = 'COPIATO!';
    
    setTimeout(function() {
      button.classList.remove('copied');
      btnText.textContent = originalText;
    }, 2000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBannerCopyButtons);
  } else {
    initBannerCopyButtons();
  }
  
  // Re-initialize after dynamic content updates (for theme compatibility)
  document.addEventListener('shopify:section:load', initBannerCopyButtons);
})();
